
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


class AppContainer extends Component {
  render() {
    return (
      <>
        <div>{this.props.children}</div>
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        /></>
    );
  }
}
export default withRouter(AppContainer)
